
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/players",
      function () {
        return require("private-next-pages/players.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/players"])
      });
    }
  